import {
  Redirect,
  Route,
  Switch,
  BrowserRouter as Router,
} from 'react-router-dom';
import routes from './routes';
import PrivateRoute from './components/PrivateRoute';
import NotFound from './screens/NotFound/NotFound';

function App(props) {
  const routeComponent = (r) => {
    return (
      <r.component
        form={r.form}
        content={r.content}
        title={r.title}
        titleSubmitted={r.titleSubmitted}
      />
    );
  };

  if (props.test) {
    return (
      <Switch>
        {routes
          .filter((r) => !r.layout)
          .map((r) => (
            <Route exact={r.exact} path={r.path} key={r.path}>
              {routeComponent(r)}
            </Route>
          ))}
        <Route exact path={'/'}>
          <Redirect to="/login" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    );
  }
  return (
    <Router>
      <Switch>
        {routes
          .filter((r) => !r.layout)
          .map((r) =>
            r.private ? (
              <PrivateRoute exact={r.exact} path={r.path} key={r.path}>
                {routeComponent(r)}
              </PrivateRoute>
            ) : (
              <Route exact={r.exact} path={r.path} key={r.path}>
                {routeComponent(r)}
              </Route>
            )
          )}
        <Route exact path={'/'}>
          <Redirect to="/login" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
}

export default App;
